function initMap() {
  const mapdiv = document.getElementById('map');

  if (mapdiv) {
    const markers = JSON.parse(mapdiv.dataset.markers);

    const map = new google.maps.Map(mapdiv, {
      center: { lat: 53.5526818, lng: 9.9611230 },
      zoom: 15,
      styles: [
        {
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#1d2c4d"
            }
          ]
        },
        {
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#8ec3b9"
            }
          ]
        },
        {
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#1a3646"
            }
          ]
        },
        {
          "featureType": "administrative.country",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#4b6878"
            }
          ]
        },
        {
          "featureType": "administrative.land_parcel",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#64779e"
            }
          ]
        },
        {
          "featureType": "administrative.province",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#4b6878"
            }
          ]
        },
        {
          "featureType": "landscape.man_made",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#334e87"
            }
          ]
        },
        {
          "featureType": "landscape.natural",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#023e58"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#283d6a"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#6f9ba5"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#1d2c4d"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#023e58"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#3C7680"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#304a7d"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#98a5be"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#1d2c4d"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#2c6675"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#255763"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#b0d5ce"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#023e58"
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#98a5be"
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#1d2c4d"
            }
          ]
        },
        {
          "featureType": "transit.line",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#283d6a"
            }
          ]
        },
        {
          "featureType": "transit.station",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#3a4762"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#0e1626"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#4e6d70"
            }
          ]
        }
      ]
    });

    if (markers && markers.length > 0) {
      markers.forEach((markerData) => {
        const marker = new google.maps.Marker({
          position: markerData.coords,
          map: map,
          title: markerData.title,
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            fillColor: '#0554F2',
            fillOpacity: 1,
            scale: 12,
            strokeColor: 'rgb(5, 84, 242, 0.5)',
            strokeWeight: 10,
          },
        });

        const infoWindow = new google.maps.InfoWindow({
          content: `<div class="marker-title">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M8 3.75C7.4561 3.75 6.92442 3.91128 6.47218 4.21346C6.01995 4.51563 5.66747 4.94512 5.45933 5.44762C5.25119 5.95012 5.19673 6.50305 5.30284 7.0365C5.40895 7.56995 5.67086 8.05995 6.05546 8.44454C6.44005 8.82914 6.93005 9.09105 7.4635 9.19716C7.99695 9.30327 8.54988 9.24881 9.05238 9.04067C9.55488 8.83253 9.98437 8.48005 10.2865 8.02782C10.5887 7.57558 10.75 7.0439 10.75 6.5C10.7492 5.77091 10.4592 5.07192 9.94363 4.55637C9.42808 4.04082 8.72909 3.75083 8 3.75ZM8 7.75C7.75277 7.75 7.5111 7.67669 7.30554 7.53934C7.09998 7.40199 6.93976 7.20676 6.84515 6.97835C6.75054 6.74995 6.72579 6.49861 6.77402 6.25614C6.82225 6.01366 6.9413 5.79093 7.11612 5.61612C7.29093 5.4413 7.51366 5.32225 7.75614 5.27402C7.99861 5.22579 8.24995 5.25054 8.47835 5.34515C8.70676 5.43976 8.90199 5.59998 9.03934 5.80554C9.17669 6.0111 9.25 6.25277 9.25 6.5C9.25 6.83152 9.1183 7.14946 8.88388 7.38388C8.64946 7.6183 8.33152 7.75 8 7.75ZM8 0.75C6.47551 0.751654 5.01394 1.35799 3.93596 2.43596C2.85799 3.51394 2.25165 4.97551 2.25 6.5C2.25 11.335 7.3525 14.9625 7.57 15.1144C7.69604 15.2026 7.84616 15.2499 8 15.2499C8.15384 15.2499 8.30396 15.2026 8.43 15.1144C9.39642 14.4021 10.2806 13.5846 11.0662 12.6769C12.8219 10.6606 13.75 8.52312 13.75 6.5C13.7483 4.97551 13.142 3.51394 12.064 2.43596C10.9861 1.35799 9.52449 0.751654 8 0.75ZM9.95625 11.6694C9.36033 12.3539 8.70576 12.985 8 13.5556C7.29424 12.985 6.63967 12.3539 6.04375 11.6694C5 10.4606 3.75 8.58187 3.75 6.5C3.75 5.37283 4.19777 4.29183 4.9948 3.4948C5.79183 2.69777 6.87283 2.25 8 2.25C9.12717 2.25 10.2082 2.69777 11.0052 3.4948C11.8022 4.29183 12.25 5.37283 12.25 6.5C12.25 8.58187 11 10.4606 9.95625 11.6694Z" fill="#2D3941"/>
                    </svg>
                    <span>${markerData.title}<span>
                  </div>`,
        });

        infoWindow.open(map, marker);
      });
    }
  }
}

window.initMap = initMap;